import React, { useState } from "react";
import Navbar from "../component/navbar";
import ContactUs from "../component/contactus";
import "../component/mainSign.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../reducer/user.reducer";
import { UserApi } from "../apis";
import {
  TextField,
  InputAdornment,
  IconButton,
  InputLabel,
  Alert,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TrialBtn from "../Components/PVX/Home/Components/trialBtn";
import CustomInput from "../component/customInput";

const SignIn = ({ setIsAuth }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const UserRouter = UserApi();

  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");
  const [displaySendModal, setDisplaySendModal] = useState(false);

  const toggleSendModal = () => setDisplaySendModal(!displaySendModal);

  const handleSignIn = async () => {
    try {
      const isValid = validate();
      if (!isValid) return null;
      setLoader(true);
      const res = await UserRouter.userLogin({
        email: email,
        password: password,
      });
      if (res.status !== 200 && res.status !== 201) {
        setLoader(false);
        const msg =
          res?.error?.response?.data?.message || "An unknown error occurred";
        setMessage(msg);
        setAlertType("error");
        setShowAlert(true);
      } else {
        dispatch(setUser({ ...res?.data?.data }));
        const check = res?.data?.data?.user?.roles[0].enums;
        if (check === "SUPER") {
          navigate("/admins");
        } else if (check === "SALES_ADMIN") {
          navigate("/customers");
        } else {
          navigate("/dashboard");
        }
      }
      setLoader(false);
    } catch (error) {
      console.log("Login Error", error);
    }
  };

  const forgetPassword = async () => {
    setEmail("")
    try {
      let isValid = true;
      if (!email) {
        setEmailErr("Email is required");
        isValid = false;
      }

      if (!isValid) return null;

      const res = await UserRouter.forgetPasswordSend({
        email: email
      })
      console.log(res)

      if (res.status !== 200 && res.status !== 201) {
        const msg =
          res?.error?.response?.data?.message || "An unknown error occurred";
        setMessage(msg);
        setAlertType("error");
        setShowAlert(true);
      } else {
        toggleSendModal()
        const msg = res?.data?.message
        setMessage(msg);
        setAlertType("success");
        setShowAlert(true);
        
      }

    } catch (error) {
      console.log("Login Error", error);
    }
  }

  const validate = () => {
    let isValid = true;
    if (!email) {
      setEmailErr("Email is required");
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailErr("Please enter a valid email");
      isValid = false;
    }

    if (!password) {
      setPasswordErr("Password is required");
      isValid = false;
    }

    return isValid; // No errors
  };

  return (
    <>
      {loader && (
        <div
          className="center"
          style={{ backgroundColor: "#000000db", position: "fixed" }}
        >
          <div className="ring"></div>
          <img src="./images/Logos/flash.svg" alt="logo"></img>
        </div>
      )}

      {/* Forget Password Email Send Dialog */}
      <Dialog open={displaySendModal} onClose={toggleSendModal}>
        <DialogTitle>Forget Password</DialogTitle>
        <DialogContent>
          <CustomInput
            id="email"
            name="email"
            title="Enter Email"
            titleRequired={true}
            isRequired={true}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailErr("");
            }}
            type="text"
            placeholder="enter email"
            required={emailErr.length > 0 ? true : false}
            helperText={emailErr}
            width="100%"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleSendModal}>Cancel</Button>
          <Button onClick={forgetPassword}>Send</Button>
        </DialogActions>
      </Dialog>

      {/* <Navbar /> */}
      <Navbar></Navbar>
      <div className="request-demo-backgroud signInForm">
        <img
          src="./images/PVX/Group1.svg"
          alt="group"
          className="group-image"
          style={{ left: "-147px", top: "100px" }}
        />
        <img
          src="./images/PVX/Group2.svg"
          alt="group"
          className="group-image"
          style={{ left: "-60px", top: "400px" }}
        />
        <img
          src="./images/PVX/Group3.svg"
          alt="group"
          className="group-image"
          style={{ left: "-100px", top: "800px" }}
        />
        <form className="request-form">
          <div className="title">Sign In</div>
          <InputLabel sx={{ color: "white" }}>Email</InputLabel>
          <TextField
            id="email"
            name="email"
            placeholder="enter email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailErr("");
            }}
            fullWidth
            variant="outlined"
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: emailErr.length > 0 ? "red" : "white",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "white",
                },
              },
              "& input": {
                color: "white",
              },
            }}
            helperText={emailErr}
            error={emailErr.length > 0 ? true : false}
          />
          <InputLabel sx={{ color: "white" }}>Password</InputLabel>
          <TextField
            id="password"
            name="password"
            placeholder="enter password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordErr("");
            }}
            fullWidth
            variant="outlined"
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: passwordErr.length > 0 ? "red" : "white",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "white",
                },
              },
              "& input": {
                color: "white",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    sx={{ color: "white" }}
                  >
                    {!showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText={passwordErr}
            error={passwordErr.length > 0 ? true : false}
          />
          <div className="logIn" onClick={handleSignIn}>
            Sign In
          </div>
          <h5 className="forgetPassword" onClick={toggleSendModal}>Forget Password</h5>
          <p className="info">
            Chrome latest versions are recommended, with an optimal resolution
            1920*1080 pixels. Copyright © Smith PVX Solar Design Tool, Ltd. All
            rights reserved.<br></br> Privacy Policy | Terms of Use
            | Cookies Policy
          </p>
        </form>
      </div>
      <ContactUs />
      <TrialBtn />

      {showAlert && (
        <Alert
          severity={alertType}
          sx={{
            position: "absolute",
            top: "100px",
            right: "20px",
            width: "300px",
          }}
        >
          {message}
        </Alert>
      )}
    </>
  );
};

export default SignIn;
